export type SupplierCategory =
  | 'Hotel & Resort'
  | 'Airline'
  | 'DMC & Tour Operator'
  | 'Visa Service'
  | 'Transfer & Transport'
  | 'Cruise Line'
  | 'Safari & Adventure';

export type SupplierStatus = 'Active' | 'Inactive' | 'Preferred' | 'Blacklisted';

export interface ServiceRate {
  id: string;
  service: string;
  unit: string;
  costPrice: number;
  markupPct: number;
  sellPrice: number;
  currency: string;
  season: string;
  validFrom: string;
  validTo: string;
}

export interface SupplierContact {
  name: string;
  role: string;
  email: string;
  phone: string;
  whatsapp?: string;
}

export interface SupplierBooking {
  bookingId: string;
  customerName: string;
  service: string;
  travelDate: string;
  pax: number;
  costAmount: number;
  sellAmount: number;
  currency: string;
  status: 'Confirmed' | 'Completed' | 'Cancelled' | 'Pending';
  refNo: string;
}

export interface Supplier {
  id: string;
  name: string;
  category: SupplierCategory;
  status: SupplierStatus;
  country: string;
  city: string;
  website: string;
  description: string;
  logo: string;
  logoColor: string;
  rating: number;
  reviewCount: number;
  paymentTerms: string;
  currency: string;
  contacts: SupplierContact[];
  rates: ServiceRate[];
  bookings: SupplierBooking[];
  tags: string[];
  totalBookings: number;
  totalCostValue: number;
  totalSellValue: number;
  lastUsed: string;
  contractExpiry: string;
  notes: string;
  createdAt: string;
}

export const suppliersData: Supplier[] = [];

export const categoryConfig: Record<SupplierCategory, { icon: string; color: string; bg: string }> = {
  'Hotel & Resort': { icon: 'ri-hotel-line', color: 'text-teal-600', bg: 'bg-teal-50' },
  'Airline': { icon: 'ri-flight-takeoff-line', color: 'text-sky-600', bg: 'bg-sky-50' },
  'DMC & Tour Operator': { icon: 'ri-map-2-line', color: 'text-amber-700', bg: 'bg-amber-50' },
  'Visa Service': { icon: 'ri-passport-line', color: 'text-violet-600', bg: 'bg-violet-50' },
  'Transfer & Transport': { icon: 'ri-car-line', color: 'text-orange-600', bg: 'bg-orange-50' },
  'Cruise Line': { icon: 'ri-ship-line', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  'Safari & Adventure': { icon: 'ri-tree-line', color: 'text-green-700', bg: 'bg-green-50' },
};

export const statusConfig: Record<SupplierStatus, { color: string; bg: string; dot: string }> = {
  Active: { color: 'text-emerald-700', bg: 'bg-emerald-50', dot: 'bg-emerald-400' },
  Preferred: { color: 'text-amber-700', bg: 'bg-amber-50', dot: 'bg-amber-400' },
  Inactive: { color: 'text-gray-500', bg: 'bg-gray-100', dot: 'bg-gray-300' },
  Blacklisted: { color: 'text-red-600', bg: 'bg-red-50', dot: 'bg-red-400' },
};
